import { useContext } from "react";

import { OneDriveSyncContextMenuContext } from "./OneDriveSyncContextMenuContext";

export function useOneDriveSyncContextMenu() {
  const context = useContext(OneDriveSyncContextMenuContext);
  if (!context) {
    throw new Error("useOneDriveSyncContextMenu must be used within a OneDriveSyncContextMenuProvider");
  }
  return context;
}
